import { CookieConfigProps, cookiesConfig } from "@/services/storage/datastore/cookiesConfig";
import { Base64DecoderService } from "@/services/storage/decoder/Base64DecoderService";
import { Base64EncoderService } from "@/services/storage/encoder/Base64EncoderService";
import { setCookie, getCookie, hasCookie, deleteCookie } from "cookies-next";

const encoder = new Base64EncoderService();
const decoder = new Base64DecoderService();

const AMPLITUDE_COOKIE_PREFIXES = ["amp_", "amplitude_"] as const;

export const isAmplitudeCookie = (name: string): boolean => {
  const normalizedName = name.trim().toLowerCase();
  return AMPLITUDE_COOKIE_PREFIXES.some((prefix) => normalizedName.startsWith(prefix));
};

export const utmList = [
  "utm_source",
  "utm_campaign",
  "utm_medium",
  "utm_term",
  "utm_content",
  "utm_adgroup",
  "utm_network",
  "utm_device",
  "utm_devicemodel",
  "utm_matchtype",
  "utm_loc_physical_ms",
  "utm_campaigntype",
  "gclid",
  "msclkid",
  "tag",
];

export const getCookieExpiration = (cookieName: string) => {
  const cookieConfig = cookiesConfig.find((config: CookieConfigProps) =>
    config.keys.includes(cookieName)
  );

  return cookieConfig ? cookieConfig.expires : null;
};

export const getCookieValue = (name: string) => {
  if (hasCookie(name)) {
    const cookieValue = getCookie(name)!;

    try {
      const decodedValue = decoder.decode(cookieValue as string);
      const parsedContent = JSON.parse(decodedValue);
      return parsedContent;
    } catch (e) {
      console.warn("Cookie decode/parse failed:", e);
      return cookieValue;
    }
  }
};

export const setCookieValue = (name: string, value: any) => {
  const jsonValue = JSON.stringify(value);
  const encodedValue = encoder.encode(jsonValue);
  const expiration = getCookieExpiration(name);

  if (expiration) {
    setCookie(name, encodedValue, { expires: new Date(Date.now() + expiration) });
  } else {
    setCookie(name, encodedValue);
  }
};

export const removeCookie = (name: string) => {
  if (isAmplitudeCookie(name)) return;
  deleteCookie(name);
};

export const removeAllUtmCookies = () => {
  utmList.forEach((utm) => removeCookie(utm));
};

export const removeAllCookies = () => {
  document.cookie.split(";").forEach((cookie) => {
    const name = cookie.split("=")[0].trim();
    if (!name || isAmplitudeCookie(name)) return;

    document.cookie = `${name}=;expires=${new Date().toUTCString()};path=/`;
  });
};
